const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const eur = (n) => `${(n || 0).toFixed(2)} €`;

const itemRow = (i) => `<div class="row"><span>${i.quantity}× ${esc(i.name)}</span><span>${eur(i.total ?? i.price * i.quantity)}</span></div>`;

export const printConciergeTicket = (d) => {
  const w = window.open("", "_blank");
  const date = new Date(d.created_at).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  const count = d.items.reduce((s, i) => s + i.quantity, 0);
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Bon ${esc(d.tracking_number || "")}</title>
    <style>
      @page { size: 80mm auto; margin: 0; }
      * { color: #000 !important; font-weight: bold; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      body { font-family: 'Courier New', monospace; width: 80mm; margin: 0 auto; padding: 4mm; font-size: 13px; line-height: 1.3; box-sizing: border-box; }
      .brand { text-align: center; margin-bottom: 6px; }
      .star { font-size: 40px; line-height: 1; }
      .name { font-size: 20px; font-weight: 900; letter-spacing: 1px; }
      .box { text-align: center; border: 3px solid #000; padding: 6px; margin: 6px 0; font-weight: 900; }
      .big { font-size: 20px; }
      .row { display: flex; justify-content: space-between; gap: 6px; margin: 3px 0; font-size: 12px; }
      .sep { border-top: 3px dashed #000; margin: 8px 0; }
      .footer { text-align: center; font-size: 11px; margin-top: 10px; }
    </style></head><body>
    <div class="brand"><div class="star">★</div><div class="name">L'ÉTOILE PART-DIEU</div><div>Conciergerie</div></div>
    ${d.tracking_number ? `<div class="box big">MARQUAGE : ${esc(d.tracking_number)}</div>` : ""}
    <div class="box">${esc(d.person_name)}${d.company_name ? `<br>${esc(d.company_name)}` : ""}</div>
    <div class="row"><span>Date dépôt :</span><span>${date}</span></div>
    <div class="sep"></div>
    <div style="text-align:center;font-weight:900;">ARTICLES DÉPOSÉS</div>
    ${d.items.map(itemRow).join("")}
    <div class="sep"></div>
    <div class="row"><span>${count} article(s)</span><span>${eur(d.subtotal ?? d.total)}</span></div>
    ${d.credit_used ? `<div class="row"><span>Avoir utilisé</span><span>-${eur(d.credit_used)}</span></div>` : ""}
    <div class="box big">TOTAL : ${eur(d.total)}</div>
    <div class="footer">Merci de votre confiance !<br>L'Étoile Part-Dieu</div>
    <script>window.onload = function() { window.print(); }</script>
    </body></html>`);
  w.document.close();
};
